export const handleNameInput = search => {
    let isDefaultView = !search;
    return isDefaultView;
}